module.exports = __webpack_public_path__ + "img/rondinter.cebd7f5e.svg";